import {
	IoIosArrowRoundBack,
	IoIosArrowForward,
	IoIosArrowDown,
} from 'react-icons/io';
import {
	MimaText,
	MimaDropdown,
	MimaButton,
	MimaInput,
} from '../../components';
import styles from '../../assets/styles/ProductDisplay/ProductDisplay.module.scss';
import { amountFormatter } from '../../utils/utils';
import countries from '../../utils/countries.json';
import { invoiceStore } from '../../stores';
import { Formik } from 'formik';
import React from 'react';

const ProductCheckOut = ({
	isToggle,
	history,
	toggleSummary,
	pay,
	showPay,
	loading,
	goBack,
	onSubmit,
	customerDetailsValidation,
	preCheckOutData,
	goToMimaCheckout,
}) => {
	const {
		business,
		transactionAmount,
		orders,
		number,
		vat,
		shipping,
		deliveryDate,
		paymentUrl,
	} = invoiceStore.selectedInvoice;
	const MimaLogo = "https://res.cloudinary.com/mima-business/image/upload/v1669813147/mima-logo_wzrulf.png"
	return (
		<div className={styles.ciWrapper}>
			{!pay && (
				<>
					<div className={styles.ci__titleBox}>
						<IoIosArrowRoundBack onClick={() => history(-1)} />
						{/* <IoIosArrowRoundBack onClick={goBack}/> */}
						<MimaText
							variant="smallBold"
							style={{ textTransform: 'uppercase' }}
							color="var(--color-primary)">
							{ }
						</MimaText>
					</div>

					<div className={styles.ci__container}>
						<div className={styles.ci__details}>
							<MimaText variant="subtitleBold" mb={3}>
								Customer Information
							</MimaText>

							<Formik
								initialValues={{
									fullname: '',
									mobile: '',
									email: '',
									country: '',
									state: '',
									//town: '',
									street: '',
								}}
								validationSchema={customerDetailsValidation}
								onSubmit={onSubmit}>
								{({
									handleChange,
									handleBlur,
									handleSubmit,
									setFieldValue,
									values,
									errors,
									touched,
								}) => (
									<div>
										<MimaInput
											labelTitle="Full Name"
											type="text"
											placeholder="Enter your Full name"
											name="fullname"
											value={values.fullname}
											onChange={handleChange}
											onBlur={handleBlur}
											error={errors.fullname}
											touched={touched.fullname}
										/>
										<MimaInput
											labelTitle="Email Address"
											type="email"
											placeholder="Enter your email address"
											name="email"
											value={values.email}
											onChange={handleChange}
											onBlur={handleBlur}
											error={errors.email}
											touched={touched.email}
										/>
										<MimaInput
											labelTitle="Phone Number"
											type="tel"
											placeholder="Enter your Phone Number"
											name="mobile"
											value={values.mobile}
											onChange={handleChange}
											onBlur={handleBlur}
											error={errors.mobile}
											touched={touched.mobile}
										/>
										<MimaDropdown
											labelTitle="Country"
											name="country"
											value={values.country}
											currentValue={values.country}
											placeholder={values.country}
											id="countryy"
											onChange={data => {
												setFieldValue('country', data.key);
											}}
											data={countries.map(value => {
												return {
													key: value.country,
													value: value.country,
												};
											})}
											touched={touched.country}
										/>
										<MimaDropdown
											labelTitle="State"
											name="state"
											currentValue={values.state}
											placeholder={values.state}
											value={values.state}
											id="state"
											onChange={data => {
												setFieldValue('state', data.key);
											}}
											data={
												countries
													.find(value => value.country === values.country)
													?.states.map(state => {
														return {
															key: state,
															value: state,
														};
													}) || []
											}
											touched={touched.state}
										/>
										{/* <MimaInput
                      labelTitle="Town/City"
                      type="text"
                      placeholder="Enter your Town/City"
                      name="town"
                      value={values.town}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.town}
                      touched={touched.town}
                    /> */}
										<MimaInput
											labelTitle="Street Address"
											type="text"
											placeholder="Enter your Address"
											name="street"
											value={values.street}
											onChange={handleChange}
											onBlur={handleBlur}
											error={errors.street}
											touched={touched.street}
										/>

										<MimaButton
											title="Proceed"
											loading={loading}
											type="submit"
											mt={4}
											onClick={handleSubmit}
										/>
									</div>
								)}
							</Formik>
						</div>

						<div className={styles.ci__summary}>
							<div>
								<div className={styles.ci__toggle} onClick={toggleSummary}>
									<MimaText variant="smallBold" color="var(--color-primary)">
										{isToggle ? 'Hide' : 'Show'} Order Summary
									</MimaText>
									{isToggle ? <IoIosArrowDown /> : <IoIosArrowForward />}
								</div>
								{isToggle && (
									<div style={{ transition: 'all 5s ease' }}>
										<div className={styles.ci__order}>
											<MimaText variant="smallBold">PRODUCT</MimaText>
											<MimaText variant="smallBold">Price</MimaText>
										</div>

										<div className={styles.ci__order}>
											<MimaText variant="small">
												{`${preCheckOutData.title || ''}
                    								- ${preCheckOutData?.variations?.map(
													variant => `${variant.type}: ${variant.value} `
												) || ''
													} - ${amountFormatter(preCheckOutData.currencyCode).format(
														preCheckOutData.sellingPrice
													)}`}
											</MimaText>
											<MimaText variant="smallBold">
												{amountFormatter(preCheckOutData.currencyCode).format(preCheckOutData.sellingPrice)}
											</MimaText>
										</div>

										<div className={styles.ci__order}>
											<MimaText variant="smallBold">Sub-Total</MimaText>
											<MimaText variant="smallBold">
												{amountFormatter(preCheckOutData.currencyCode).format(
													preCheckOutData.sellingPrice *
													preCheckOutData.quantity
												)}
											</MimaText>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</>
			)}

			{pay && (
				<>
					<div className={styles.ci__titleBox}>
						<IoIosArrowRoundBack onClick={goBack} />
						<MimaText
							variant="smallBold"
							style={{ textTransform: 'uppercase' }}
							color="var(--color-primary)">
							{business?.tradingName}
						</MimaText>
					</div>

					<div className={styles.ps__container}>
						<div className={styles.ps__order}>
							<div className={styles.ci__toggle} onClick={toggleSummary}>
								<MimaText variant="smallBold" color="var(--color-primary)">
									{isToggle ? 'Hide' : 'Show'} Order Summary
								</MimaText>
								{isToggle ? <IoIosArrowDown /> : <IoIosArrowForward />}
							</div>

							{isToggle && (
								<div>
									<div className={styles.ci__order}>
										<MimaText variant="smallBold">PRODUCT</MimaText>
										<MimaText variant="smallBold">Price</MimaText>
									</div>
									{orders.map(order => (
										<div className={styles.ci__order}>
											<MimaText variant="small">
												{order.item}x{order.quantity}
											</MimaText>
											<MimaText variant="smallBold">{order.itemPrice}</MimaText>
										</div>
									))}

									<div className={styles.ci__order}>
										<MimaText variant="smallBold">Shipping</MimaText>
										<MimaText variant="smallBold">{shipping}</MimaText>
									</div>

									{vat && (
										<div className={styles.ci__order}>
											<MimaText variant="smallBold">VAT (7.5%)</MimaText>
											<MimaText variant="smallBold">
												{amountFormatter().format(vat?.amount)}
											</MimaText>
										</div>
									)}

									<div className={styles.ci__order}>
										<MimaText variant="smallBold">Total</MimaText>
										<MimaText variant="smallBold">{transactionAmount}</MimaText>
									</div>
									{shipping && (
										<div className={styles.ci__order}>
											<MimaText variant="smallBold">Delivery Dates</MimaText>
											<div>
												<div className={styles.ci__order_shipping}>
													<MimaText variant="small">{deliveryDate}</MimaText>
												</div>
											</div>
										</div>
									)}
								</div>
							)}
						</div>

						{business?.bankAccount === undefined ? (
							<div className={styles.ps__payment}>
								<MimaButton
									title="Click to Pay"
									onClick={goToMimaCheckout}
								/>
							</div>) : (
							<div className={styles.ps__payment}>
								<MimaText variant="smallBold" mb={2}>
									Kindly Remit Payment to:
								</MimaText>

								<div className={styles.ci__order_payment_details}>
									<MimaText variant="small">Bank: &nbsp;</MimaText>
									<MimaText variant="smallBold">
										{business?.bankAccount?.bank}
									</MimaText>
								</div>

								<div className={styles.ci__order_payment_details}>
									<MimaText variant="small">Account Name: &nbsp;</MimaText>
									<MimaText variant="smallBold">
										{business?.bankAccount?.accountName}
									</MimaText>
								</div>

								<div className={styles.ci__order_payment_details}>
									<MimaText variant="small">Account Number: &nbsp;</MimaText>
									<MimaText variant="smallBold">
										{business?.bankAccount?.accountNumber}
									</MimaText>
								</div>

								<div className={styles.ci__order_payment_details}>
									<MimaText variant="small">Narration Code: &nbsp;</MimaText>
									<MimaText variant="smallBold">{`INV-${number}`}</MimaText>
								</div>
								<div className={styles.ci__order_payment_details}>
									<MimaText variant="smallBold">Total &nbsp;</MimaText>
									<MimaText variant="smallBold">{transactionAmount}</MimaText>
								</div>
							</div>
						)}
					</div>
				</>
			)}

			<div className={styles.mima}>
				<p>Powered by</p> <img src={MimaLogo} className={styles.mima__logo} />
			</div>
		</div>
	);
};

export default ProductCheckOut;
